import cn from 'classnames';
import {Modal, Socials, Tooltip} from '../../components'
import styles from './Hero.module.scss';
import logo from '../../resources/icons/logo.svg';
import partner from '../../resources/icons/partner.svg';
import {ReactComponent as Play} from '../../resources/icons/play.svg';
import {useState} from "react";

const kaspersky = 'https://allsoft.kaspersky.ru/basket/add/4669584?clear=Y&reseller=kl-ru_22ru-2X2_pro_ona_oth__onl_b2c_2x2_lnk_2x2___kis___',
    videoArray = [
        <iframe className="frame" src="https://www.youtube.com/embed/_lWj3m0v9KM?autoplay=1" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />,
        <iframe  className="frame" src="https://www.youtube.com/embed/1xPJhZF9zrs?autoplay=1" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />,
        <iframe className="frame" src="https://www.youtube.com/embed/kGygLS8uUBw?autoplay=1" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
    ];

export const Hero = () => {
    const [modal, checkoutModal] = useState(false);
    const [current, checkoutCurrent] = useState(1);

    const handlerModal = index => {
        checkoutCurrent(index);
        checkoutModal(!modal);
    }

    const videoList = ['first', 'second', 'third'].map((item, index) => {
        return (
            <div key={index} className={cn(styles.screen, styles[`screen_${item}`])}>
                <div className={cn(styles.play, 'play-button')} onClick={() => handlerModal(index)}>
                    <Play className={styles.player}/>
                </div>
            </div>
        )
    })

    const tooltipVideo = <iframe className={styles.framer}  src="https://www.youtube.com/embed/kGygLS8uUBw"
                             title="YouTube video player" frameBorder="0"
                             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                             allowFullScreen />;

    return (
        <div className={styles.hero}>
            <header className={styles.header}>
                <a href="https://2x2tv.ru" className={styles.link} target="_blank" rel="nofollow noreferrer">
                    <img src={logo} className={styles.logo} alt="2x2"/>
                </a>
                <a href={kaspersky} className={styles.partner} target="_blank" rel="nofollow noreferrer">
                    <img src={partner} className={styles.logo} alt="Kaspersky"/>
                </a>
            </header>
            <div className={styles.body}>
                <h1 className="h1">Кибер Кринж</h1>
                <div className={cn('lead', styles.desc)}>С вами приключился киберкринж? Вы претендуете на его экранизацию от 2х2 и Kaspersky!</div>
                <Tooltip text="КИБЕР-КРИ́НЖ, -и, м — история, ситуация, событие в виртуальном пространстве, вызывающее невиртуальный кринж" video={tooltipVideo}/>
            </div>
            <div className={styles.figure}>
                {videoList}
            </div>
            <div className={styles.copyright}>РЕКЛАМА<br/>АО «Лаборатория Касперского»</div>
            <Socials className={styles.socials}/>
            <Modal open={modal} closer={handlerModal}>
                {videoArray[current]}
            </Modal>
        </div>
    )
}